import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Supports',
  components: {
    SupportComp: require('./support.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      supports: [],
      supportServices: [],
      supportServiceTypes: [],
      teams: [],
      stations: [],
      bSupportDialog: false,
      bConfirmDialog: false,
      deleteConfirmMessage: '',
      editingSupport: {

      },
      editingSupportClone: {

      },
      message: '',
    }
  },
  created() {
    //this.dataObj.
    console.log("supports data", this.dataObj);
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init);
    this.init();
  },
  methods: {
    formatMoney(number, decPlaces, decSep, thouSep) {
      decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSep = typeof decSep === "undefined" ? "." : decSep;
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - parseInt(i)).toFixed(decPlaces).slice(2) : "");
    }, //this.formatMoney(item.closingBalance, 2, '.', ',');
    init() {
      Vue.nextTick(() => {
        this.dataObj.appData.actualSupportUsages.forEach(p => {
          p.totalCost = this.formatMoney(p.totalCost, 2, '.', ',');
          if (!p.uuid || p.uuid.length === 0)
            p.uuid = uuidv4();
        });
        if (this.dataObj.appData.actualSupportUsages)
          this.supports = this.dataObj.appData.actualSupportUsages;
        else
          this.dataObj.appData.actualSupportUsages = [];
        this.supportServices = this.dataObj.appData.supportServices;
        this.supportServiceTypes = this.dataObj.appData.supportServiceTypes;
        this.teams = this.dataObj.appData.teams;
        this.stations = this.dataObj.appData.stations;
      });
    },
    addSupport() {
      this.editingSupportClone = {
        isMultiple: true,
        selection: [],
        additionalCost: 0,
        comment: '',
        dt: this.dataObj.appData.startDt,
        id: 0,
        logDescription: '',
        logValue: 0,
        name: '',
        rateHr: 0,
        supportService: '',
        supportServiceId: 0,
        supportServiceType: '',
        supportServiceTypeId: 0,
        showSupportServicesRates: this.dataObj.appData.settings.showSupportServicesRates,
        totalCost: 0,
        travelDistance: this.dataObj.appData.travelKm,
        travelDuration: this.dataObj.appData.actualTravelDuration,
        workDuration: this.dataObj.appData.actualJobDuration,
        uuid: uuidv4(),
        supportServices: this.supportServices,
        supportServiceTypes: this.supportServiceTypes,
        teams: this.teams,
        stations: this.stations,
        maxJobDuration: this.dataObj.appData.actualJobDuration == null ? '0' : this.dataObj.appData.actualJobDuration,
        maxTravelDuration: this.dataObj.appData.actualTravelDuration == null ? '0' : this.dataObj.appData.actualTravelDuration,
        maxTravelKm: this.dataObj.appData.travelKm == null ? '0' : this.dataObj.appData.travelKm,
        isEdit: false,
        employees: this.dataObj.appData.employees,
        assignedEmployeeId: this.dataObj.appData.assignedEmployeeId,
        applicationStationId: this.dataObj.appData.applicationStationId,
        stationId: this.dataObj.appData.stationId
      };
      //console.log("clone supports", this.editingSupportClone);

      this.$root.$emit('reset_select_from_list');
      this.bSupportDialog = true;
    },
    editSupport(item) {
      this.editingSupport = item;
      this.editingSupportClone = JSON.parse(JSON.stringify(item));
      this.editingSupportClone.supportServices = this.supportServices;
      this.editingSupportClone.supportServiceTypes = this.supportServiceTypes;
      this.editingSupportClone.showSupportServicesRates = this.dataObj.appData.settings.showSupportServicesRates;
      this.editingSupportClone.teams = this.teams;
      this.editingSupportClone.stations = this.stations;
      this.editingSupportClone.isMultiple = false;
      this.editingSupportClone.selection = [];
      this.editingSupportClone.maxJobDuration = this.dataObj.appData.actualJobDuration == null ? '0' : this.dataObj.appData.actualJobDuration;
      this.editingSupportClone.maxTravelDuration = this.dataObj.appData.actualTravelDuration == null ? '0' : this.dataObj.appData.actualTravelDuration;
      this.editingSupportClone.maxTravelKm = this.dataObj.appData.travelKm;
      this.editingSupportClone.isEdit = true;

      this.bSupportDialog = true;
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('schedule.deleteMessage') + ' [' + item.id + '. ' + item.supportService + '] ?';
      this.editingSupport = item;
      this.bConfirmDialog = true;
    },
    removeSupport() {
      this.dataObj.appData.actualSupportUsages = this.dataObj.appData.actualSupportUsages.filter(p => p.uuid !== this.editingSupport.uuid);
      this.supports = this.dataObj.appData.actualSupportUsages;
    },
    saveSupport() {
      if (this.editingSupportClone.supportServiceTypeId == null || this.editingSupportClone.supportServiceTypeId == '' || this.editingSupportClone.supportServiceTypeId < -1) {
        this.$alertMsg(this.$t('validation.supportServiceTypeRequired'));
        return;
      }

      const selection = this.editingSupportClone.selection;
      if (
        !this.editingSupportClone.isMultiple &&
        (this.editingSupportClone.supportServiceId == null || (isNaN(this.editingSupportClone.supportServiceId) && this.editingSupportClone.supportServiceId == '') || this.editingSupportClone.supportServiceId < 0)
        ||
        this.editingSupportClone.isMultiple && (!selection || selection.length == 0)
      )
      {
        this.$alertMsg(this.$t('validation.supportServiceRequired'));
        return;
      }

      if (this.editingSupportClone.workDuration > this.editingSupportClone.maxJobDuration)
        this.$alertMsg(this.$t('validation.invalidWorkDuration'));

      if (this.editingSupportClone.travelDuration > this.editingSupportClone.maxTravelDuration)
        this.$alertMsg(this.$t('validation.invalidTravelDuration'));

      if (this.editingSupportClone.travelDistance > this.editingSupportClone.maxTravelKm)
        this.$alertMsg(this.$t('validation.invalidTravelDistance'));

      if (this.editingSupportClone.travelDuration > this.editingSupportClone.maxTravelDuration ||
          this.editingSupportClone.workDuration > this.editingSupportClone.maxJobDuration ||
          this.editingSupportClone.travelDistance > this.editingSupportClone.maxTravelKm)
        return;

      this.dataObj.appData.actualSupportUsages = this.dataObj.appData.actualSupportUsages.filter(p => p.uuid !== this.editingSupportClone.uuid);


      delete this.editingSupportClone.supportServices;
      delete this.editingSupportClone.showSupportServicesRates;
      delete this.editingSupportClone.supportServiceTypes;
      delete this.editingSupportClone.teams;
      delete this.editingSupportClone.stations;
      delete this.editingSupportClone.maxJobDuration;
      delete this.editingSupportClone.maxTravelDuration;
      delete this.editingSupportClone.maxTravelKm;

      if (!this.editingSupportClone.isMultiple) {
        //this.editingSupportClone.supportServiceTypeId = this.dataObj.appData.supportServiceTypes.filter(s => s.id == this.editingSupportClone.supportServiceId && s.supportServiceTypeId == this.editingSupportClone.supportServiceTypeId)[0].supportServiceTypeId;
        //this.editingSupportClone.supportServiceType = this.dataObj.appData.supportServices.filter(s => s.id == this.editingSupportClone.supportServiceId && s.supportServiceTypeId == this.editingSupportClone.supportServiceTypeId)[0].supportServiceType;
        let support = { ...this.editingSupportClone }
        delete support.selection;
        delete support.emplyees;
        this.dataObj.appData.actualSupportUsages.push(support);
      }
      else {
        selection.forEach(p => {
          let support = { ...this.editingSupportClone };
          let sup = this.dataObj.appData.supportServices.filter(s => s.id == p.id && s.supportServiceTypeId == p.supportServiceTypeId)[0];

          support.supportServiceId = p.id;
          support.rateHr = p.rate ?? 0;
          support.uuid = uuidv4();
          support.supportServiceTypeId = sup.supportServiceTypeId;
          support.supportService = sup.name;
          support.supportServiceType = sup.supportServiceType;
          support.stationId = sup.stationId;

          if (typeof support.totalCost != 'number' || support.totalCost == 'NaN' || support.totalCost == null)
            support.totalCost = 0;

          delete support.selection;
          delete support.emplyees;

          this.dataObj.appData.actualSupportUsages.push({ ...support });
        });
      }
      
      this.supports = this.dataObj.appData.actualSupportUsages;
      this.bSupportDialog = false;
    },
    closeDialog() {
      this.bSupportDialog = false;
    },
  },
  
}

